export default __webpack_public_path__ + "static/media/zielone2.954328cc.gif";